export const DRIVER_CDL_VERIFICATION_HELP_URL =
  'https://support.superdispatch.com/hc/en-us/articles/54054733110931-How-Driver-CDL-Verification-Works-for-Carriers-and-Drivers';
